import React from 'react';
import Editor from '@monaco-editor/react';

/**
 * Monaco-based code editor component with syntax highlighting
 */
export const CodeEditor = ({ value, onChange, language, height = '300px', theme = 'vs-dark' }) => {
  const handleEditorChange = (newValue) => {
    if (onChange) {
      onChange(newValue);
    }
  };

  return (
    <Editor
      height={height}
      language={language}
      value={value}
      onChange={handleEditorChange}
      theme={theme}
      options={{
        minimap: { enabled: false },
        fontSize: 14,
        lineNumbers: 'on',
        scrollBeyondLastLine: false,
        automaticLayout: true,
        bracketPairColorization: { enabled: true },
        formatOnPaste: true,
        formatOnType: true,
        wordWrap: 'on',
        wrappingIndent: 'indent',
      }}
    />
  );
};
